import { endpoints } from "@app/api/apis";
import AsyncStorage from "@react-native-async-storage/async-storage";
import axios from "axios";



export const getPledgeDataApi = async (payload: { applicationId: string }) => {

    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }

    try {
        const response = await axios.get(endpoints.pledgeData + applicationId);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}


export const triggerOtp = async (payload: { applicationId: string , otpType: string }) => {

    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }

        const response = await axios.post(endpoints.pledgeInit , {
        otpType: payload.otpType,
        applicationId: applicationId
    }, { handle500Here: true });
    return response.data;
    
}


export const verifyPledgeOtp = async (payload: { applicationId: string , otpType: string , otp: string }) => {

    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }   

        const response = await axios.post(endpoints.assetPledgeVerify , {
            otpType: payload.otpType,
            applicationId: applicationId,
            otp: payload.otp
        }, { handle500Here: true });
        return response.data;
}



export const fetchInitV2Api = async (payload: { applicationId: string , assetRepository: string , emailId: string , panNumber: string , phoneNumber: string }) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }   
    const response = await axios.post(endpoints.fetchInitV2 , {
        applicationId: applicationId,
        assetRepository: payload.assetRepository,
        emailId: payload.emailId,
        panNumber: payload.panNumber,
        phoneNumber: payload.phoneNumber
    });
    return response.data;
}



export const authCASApi = async (payload: { applicationId: string , otp: string , assetRepository: string }) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }   
    const response = await axios.post(endpoints.authCAS , {
        applicationId: applicationId,
        otp: payload.otp,
        assetRepository: payload.assetRepository,
    });
    return response.data;
}

export const getCredentialsForAssetFetchApi = async (payload: { applicationId: string , assetRepository: string }) => {
    let applicationId = payload.applicationId;
    let applicationIdStored = await AsyncStorage.getItem('application_id')
  
    if (applicationIdStored) {
      applicationId = applicationIdStored;
    }   
    const response = await axios.post(endpoints.getCredentialsForAssetFetch , {
        applicationId: applicationId,
        assetRepository: payload.assetRepository
    });
    return response.data;
}
